// extracted by mini-css-extract-plugin
export default {"swiper-slide-active":"DownloadCars_swiper-slide-active__xF3sI","cars":"DownloadCars_cars__FhWdm"};